module.exports = __webpack_public_path__ + "static/media/Two-circle.9e71718d.png";